import { Validator } from '@vista-digital/validator';
import { customFilmActionValidator } from './custom-film-action';
export const customFilmActionsValidator = Validator.objectOf(Validator.array({ items: customFilmActionValidator }));
